import React, { useState, useEffect, useCallback } from "react";
import { ordersApi } from "../../services/api";
import EditModal from "./EditModal";
import "./Orders.css";

const PAGE_SIZES = [10, 15, 25, 50, 100];

function Orders() {
  const [orders, setOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [editOrder, setEditOrder] = useState(null);
  const [menuOpen, setMenuOpen] = useState(null);

  const fetchOrders = useCallback(async () => {
    setLoading(true);
    try {
      const data = await ordersApi.getOrders(page, pageSize);
      setOrders(data.orders || []);
      setTotal(data.total || 0);
      setTotalPages(data.totalPages || 1);
    } catch (err) {
      console.error("Failed to load orders:", err);
    }
    setLoading(false);
  }, [page, pageSize]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  const handleResend = async (id) => {
    setMenuOpen(null);
    try {
      const data = await ordersApi.resend(id);
      alert(data.success ? data.message : "Failed: " + data.error);
      fetchOrders();
    } catch (err) {
      alert("Request failed");
    }
  };

  const handleResendTracking = async (id) => {
    setMenuOpen(null);
    try {
      const data = await ordersApi.resendTracking(id);
      alert(data.success ? data.message : "Failed: " + data.error);
    } catch (err) {
      alert("Request failed");
    }
  };

  const handleEdit = (order) => {
    setMenuOpen(null);
    setEditOrder(order);
  };

  const showFrom = total > 0 ? (page - 1) * pageSize + 1 : 0;
  const showTo = Math.min(page * pageSize, total);

  return (
    <div className="orders-page">
      <div className="orders-header">
        <h1>Orders</h1>
      </div>

      <div className="orders-table-wrapper">
        <table className="orders-table">
          <thead>
            <tr>
              <th>Order</th>
              <th>Customer</th>
              <th>Phone</th>
              <th>Total</th>
              <th>Message</th>
              <th>Status</th>
              <th>Created</th>
              <th>Responded</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="9" style={{ textAlign: "center", padding: "40px", color: "var(--text-secondary)" }}>Loading...</td></tr>
            ) : orders.length === 0 ? (
              <tr><td colSpan="9" style={{ textAlign: "center", padding: "40px", color: "var(--text-secondary)" }}>No orders found</td></tr>
            ) : (
              orders.map((order) => (
                <tr key={order.id}>
                  <td>#{order.shopify_order_number}</td>
                  <td>{order.customer_name}</td>
                  <td>
                    {order.customer_phone}
                    {order.original_phone && order.original_phone !== order.customer_phone && (
                      <span className="original-phone"> (real: {order.original_phone})</span>
                    )}
                  </td>
                  <td>{order.order_total || "-"}</td>
                  <td>
                    <span className={`badge badge-${order.whatsapp_message_id ? "sent" : "notsent"}`}>
                      {order.whatsapp_message_id ? "Sent" : "Not Sent"}
                    </span>
                  </td>
                  <td>
                    <span className={`badge badge-${order.status}`}>{order.status}</span>
                  </td>
                  <td>{order.created_at}</td>
                  <td>{order.responded_at || "-"}</td>
                  <td>
                    <div className="row-menu">
                      <button className="row-menu-btn" onClick={() => setMenuOpen(menuOpen === order.id ? null : order.id)}>
                        ⋮
                      </button>
                      {menuOpen === order.id && (
                        <div className="row-dropdown">
                          <button onClick={() => handleEdit(order)}>Edit</button>
                          <button onClick={() => handleResend(order.id)}>Resend Confirmation</button>
                          <button onClick={() => handleResendTracking(order.id)}>Resend Tracking</button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="orders-pagination">
        <div className="pagination-info">
          Showing {showFrom}–{showTo} of {total} orders
          <select value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}>
            {PAGE_SIZES.map((s) => <option key={s} value={s}>{s} per page</option>)}
          </select>
        </div>
        <div className="pagination-controls">
          <button disabled={page <= 1} onClick={() => setPage(page - 1)}>Prev</button>
          <span className="pagination-page">Page {page} of {totalPages}</span>
          <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      </div>

      {editOrder && (
        <EditModal
          order={editOrder}
          onClose={() => setEditOrder(null)}
          onSave={() => { setEditOrder(null); fetchOrders(); }}
        />
      )}
    </div>
  );
}

export default Orders;
